function Home() {
    return (
      <div className="container">
        <h1>Welcome to Golf League Manager</h1>
        <p>Login or register to get started.</p>
      </div>
    );
  }
  export default Home;
  
